import React from "react";
import { createRoot } from "react-dom/client";
import Documentation from "./Documentation";

declare global {
	interface Window {
		renderDataStoreDocumentationPage: unknown;
	}
}

export function renderDataStoreDocumentationPage(rootId: string) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(<Documentation />);
}

window.renderDataStoreDocumentationPage = renderDataStoreDocumentationPage;
